import React from 'react';
import { addFilter } from '../services/navigation';

function CheckBoxFilter({ search, filter, node  }) {

	const change = e => {
		addFilter(search, filter, e.target.value, e.target.checked);
	};

	const isChecked = (key) => {
		let value = search[filter];
		return !!(value && value.indexOf(key) >= 0);
	};

	return (
		<div className="checkbox--item section--menu_item">
			<input type="checkbox" id={node.key} checked={isChecked(node.key)} value={node.key} onChange={change} />
			<label htmlFor={node.name}>{node.name}</label>
		</div>
	);
}

export default CheckBoxFilter;